// @flow
import { InstancesInternalFormsActionTypes } from './constants';

type InstancesInternalFormsAction = { type: string, payload: {} | string };

// common success
export const instancesInternalFormsApiResponseSuccess = (actionType: string, data: any): InstancesInternalFormsAction => ({
    type: InstancesInternalFormsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const instancesInternalFormsApiResponseError = (actionType: string, error: string): InstancesInternalFormsAction => ({
    type: InstancesInternalFormsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getInstanceInternalForm = (id: string): InstancesInternalFormsAction => ({
    type: InstancesInternalFormsActionTypes.GET_INSTANCE_INTERNAL_FORM,
    payload: { id },
});

export const addInstanceInternalForm = (instanceInternalForm:any):InstancesInternalFormsAction=>({
    type:InstancesInternalFormsActionTypes.ADD_INSTANCE_INTERNAL_FORM,
    payload:instanceInternalForm
})
export const updateInstanceInternalForm = (instanceInternalForm:any):InstancesInternalFormsAction=>({
    type:InstancesInternalFormsActionTypes.UPDATE_INSTANCE_INTERNAL_FORM,
    payload:instanceInternalForm
})
export const deleteInstanceInternalForm = (id:string):InstancesInternalFormsAction=>({
    type:InstancesInternalFormsActionTypes.DELETE_INSTANCE_INTERNAL_FORM,
    payload:{id}
})

export const listInstancesInternalForms = (params:any): InstancesInternalFormsAction => ({
    type: InstancesInternalFormsActionTypes.LIST_INSTANCES_INTERNAL_FORMS,
    payload: params,
});


export const resetInstancesInternalForms = (): InstancesInternalFormsAction => ({
    type: InstancesInternalFormsActionTypes.RESET,
    payload: {},
});

